import {
  UPDATE_SERVICE_GRID,
} from "Redux/ActionTypes/Service";

export function updateServices(services: any[]) {
  return {
    type: UPDATE_SERVICE_GRID,
    services
  };
}